module.exports = "../fonts/check-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check-icon.svg
// module id = 322
// module chunks = 0